import currency from 'currency.js';

export const formatCurrency = (value: string, precision = 2, symbol = '') =>
  currency(value, { precision: precision, symbol: symbol }).format();
